var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacelecicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 146.14,
    x2: 304.44,
    y1: 96.53,
    y2: 96.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    d: "M225.29 166.93a70.4 70.4 0 0 1-44.63-124.85H54.31v281.79h211.35V154.19a70.05 70.05 0 0 1-40.37 12.74zm22 113.26H72v-17.5h175.32zm0-35.05H72v-17.5h175.32zm0-35H72V192.6h175.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M225.29 175.68a79.15 79.15 0 1 1 79.15-79.15 79.24 79.24 0 0 1-79.15 79.15zm0-140.8a61.65 61.65 0 1 0 61.65 61.65 61.72 61.72 0 0 0-61.65-61.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    d: "M233.57 135v10.86h-15.35V135c-9.88-1.54-18.21-6.36-22.93-13.38l11.08-9.87a24.86 24.86 0 0 0 19.63 8.8c9.11 0 13.39-2 13.39-7.79 0-4.93-2.64-7.13-17.12-10.42-14.15-3.29-24-7.79-24-22.92 0-11.52 8.45-19.09 20-21.28v-11h15.35v11.11c8.12 1.53 14.48 5.48 20.08 11.3L242.57 80.3c-4.94-5-10.42-7.9-17.44-7.9-8.23 0-11 3-11 6.36 0 4.83 3.29 6.36 15.46 9.21s25.67 7 25.67 23.7c.03 12.5-6.66 21.06-21.69 23.33z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacelecicon);
export default __webpack_public_path__ + "static/media/facelecicon.aa365264a67c59d46647f4d70dd5b7c3.svg";
export { ForwardRef as ReactComponent };